import { useContentAiGetContentByKey } from '@mi-front/api-v2';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { useFragment } from '../../hooks/useFragment';
import { CreateFragmentContent } from './CreateFragmentContent';
import { FragmentContentLink } from './FragmentContentLink';

export function FragmentContentAiView() {
  const { fragment } = useFragment();
  const result = useContentAiGetContentByKey(`FRAGMENT:${fragment.id}`, {
    query: {
      retry: (_failureCount, error) => {
        return error?.response?.status !== 404;
      },
    },
  });

  if (result.error?.response?.status === 404) {
    return <CreateFragmentContent id={fragment.id} />;
  }

  return (
    <QueryView query={result}>
      {(data) => <FragmentContentLink content={data} />}
    </QueryView>
  );
}
